export default ({ minLength, maxLength, loanIdentifierAllowedChars }) => {
  const lengthDescription = minLength === maxLength ? `${maxLength} characters` : `${minLength} to ${maxLength} characters`;
  const allowedCharsDescription = loanIdentifierAllowedChars ? ` (0-9, ${loanIdentifierAllowedChars})` : '';
  return `Account number must be ${lengthDescription}${allowedCharsDescription}.`;
};
